export class ScoreComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.createMarkup = this.createMarkup.bind(this);
  }

  componentDidMount() {}

  renderBackground() {
    let view;
    if (
      this.props.Score.Warning == "Ligeramente Alto" ||
      this.props.Score.Warning == "Moderado"
    ) {
      view = (
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center bgYellow scoring">
          <h1 className="colorYellow">
            {this.props.Score.TotalPoints}{" "}
            {resourcesEncuesta.getResource(
              "es",
              "nsEncuesta",
              "Score.totalPoints"
            )}
          </h1>
        </div>
      );
    } else if (
      this.props.Score.Warning == "Alto" ||
      this.props.Score.Warning == "Muy Alto"
    ) {
      view = (
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center bgRed scoring">
          <h1 className="colorRed">
            {this.props.Score.TotalPoints}{" "}
            {resourcesEncuesta.getResource(
              "es",
              "nsEncuesta",
              "Score.totalPoints"
            )}
          </h1>
        </div>
      );
    } else {
      view = (
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center bgGreen scoring">
          <h1 className="colorGreen">
            {this.props.Score.TotalPoints}{" "}
            {resourcesEncuesta.getResource(
              "es",
              "nsEncuesta",
              "Score.totalPoints"
            )}
          </h1>
        </div>
      );
    }
    return view;
  }
  createMarkup() {
    return {
      __html: this.props.Score.Text,
    };
  }
  render() {
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="scoreComponent"
      >
        {compTools.estaAutenticado() && this.props.Date !== "" ? (
          <div className="text-center heading">
            <h2>
              {resourcesEncuesta.getResource(
                "es",
                "nsEncuesta",
                "Score.heading"
              )}
            </h2>
          </div>
        ) : null}
        <div>{this.renderBackground()}</div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 recomendations">
          <div className="col-xs-5 col-sm-3 col-md-3 col-lg-3 text-right one">
            <div>
              {resourcesEncuesta.getResource("es", "nsEncuesta", "Score.risk")}
            </div>
            <div>{resourcesEncuesta.getResource("es", "nsEncuesta", "Score.recommendations")}</div>
          </div>
          <div className="col-xs-7 col-sm-8 col-md-7 col-lg-7 text-left two">
            <div>{this.props.Score.Warning}</div>
            <div dangerouslySetInnerHTML={this.createMarkup()} />
          </div>
        </div>
      </div>
    );
  }
}
